import gql from 'graphql-tag';

export const getPresignedPUTURL = gql`
  query getPresignedPUTURL($path: String!) {
    getPresignedPUTURL(path: $path)
  }
`;
